<p-sidebar [(visible)]="visibleExportOperators"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'640px'}">
    <ng-template pTemplate="header">
        <div class="user-filter-header">
            Export Data
        </div>
    </ng-template>
    <p-scrollPanel [style]="{height: 'calc(79vh)'}">
        <div class="mt-2">
            <div class="export-operators-title mb-2">
                Select Date
            </div>
            <div class="flex flex-row mb-3">
                <div class="w-20rem">
                    <p-calendar [(ngModel)]="exportDto.startDate" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Select Start Date"></p-calendar>
                </div>
                <div>
                    <hr class="export-operators-hyphen" />
                </div>
                <div class="w-20rem">
                    <p-calendar [(ngModel)]="exportDto.endDate" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Select End Date"></p-calendar>
                </div>
            </div>

            <div class="flex flex-column w-20rem">
                <label class="export-data-label mb-2">Select File Type</label>
                <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Select file type"
                            optionLabel="name" optionValue="value"
                            [(ngModel)]="exportDto.fileType"></p-dropdown>
            </div>
        </div>
    </p-scrollPanel>

    <hr class="hr-filter" />

    <div class="flex justify-content-end mrg-10-0px">
        <button class="outlined-white-btn" pButton label="Print"></button>
        <button class="btn-darkblue ml-3" pButton label="Export"
                [disabled]="checkExportDtoFields()"
                (click)="clickExport()"></button>
    </div>
</p-sidebar>